import * as constants from './company-types'
import instance from '../../../services/instance'

export default {
  [constants.GET_COMPANIES_FULL_LIST] ({ commit, rootState }, params = null) {
    let url = params ? `/company/list?${params}` : '/company/list'
    return new Promise((resolve, reject) => {
      instance
        .get(url, {
          headers: {
            Authorization: 'Bearer ' + rootState.idToken,
          },
        })
        .then((res) => {
          let { result } = res.data
          commit(constants.SET_COMPANIES_FULL_LIST, result)
          resolve(result)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    })
  },
}
